module.exports = __webpack_public_path__ + "img/team@2x.58873307.png";